// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-22cef0a6] .quickbooks-spinner{width:16px !important;height:16px !important}", ""]);
// Exports
module.exports = exports;
